export const retreatFlowSteps = [
  { key: 'retreat', label: 'Retreat' },
  { key: 'attendee', label: 'Attendee' },
  { key: 'sessions', label: 'Sessions' },
  { key: 'review', label: 'Review' },
  { key: 'checkout', label: 'Checkout' }
];
